// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JwrHQ","content":"styles_content__16F5O","tableWrap":"styles_tableWrap__3lh5p"};